import { render } from "./BaseBreadCrumb.vue?vue&type=template&id=656e2ce4"
import script from "./BaseBreadCrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadCrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseBreadCrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "656e2ce4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('656e2ce4', __exports__)) {
    api.reload('656e2ce4', __exports__)
  }
  
  module.hot.accept("./BaseBreadCrumb.vue?vue&type=template&id=656e2ce4", () => {
    api.rerender('656e2ce4', render)
  })

}


export default __exports__